(function () {
  function centerActive(scrollEl) {
    var activeItem = scrollEl.querySelector('.sleepys-collection-links__item.is-active');
    if (!activeItem || typeof activeItem.scrollIntoView !== 'function') return;
    activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function initSection(section) {
    var scrollEl = section.querySelector('[data-sleepys-collection-links-scroll]');
    var prev = section.querySelector('[data-sleepys-links-prev]');
    var next = section.querySelector('[data-sleepys-links-next]');
    if (!scrollEl || !prev || !next) return;

    function scrollStep() {
      return Math.min(280, Math.max(200, scrollEl.clientWidth * 0.75));
    }

    function syncNav() {
      var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
      var sl = scrollEl.scrollLeft;
      var overflow = maxScroll > 4;

      prev.hidden = !overflow;
      next.hidden = !overflow;

      if (!overflow) return;

      prev.disabled = sl <= 2;
      next.disabled = sl >= maxScroll - 2;
    }

    function onScroll() {
      syncNav();
    }

    prev.addEventListener('click', function () {
      scrollEl.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      scrollEl.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    scrollEl.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncNav);

    centerActive(scrollEl);
    syncNav();
  }

  function initAll() {
    document.querySelectorAll('.sleepys-collection-links').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target;
    if (!root || !root.querySelector) return;
    var bar = root.querySelector('.sleepys-collection-links');
    if (bar) initSection(bar);
  });
})();
